import React from "react";
import { Stack, Typography } from "@mui/material";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import { LIVECHAT_PARTNER_BRAND } from "./livechatConstants";
import { PASTEL } from "./livechatTheme";

/**
 * DEV-1423 — "Ditangani oleh <staff terakhir yang membalas>" / "Belum ditangani" untuk chat mitra.
 * Informasi saja (bukan assignment DEV-1234) — chat tidak dikunci, staff lain tetap bisa membalas.
 * Brand lain tidak menampilkan apa-apa.
 */
export default function HandledByLabel({ session, sx }) {
    if (session?.brand !== LIVECHAT_PARTNER_BRAND) return null;
    const handled = session.lastHandledByAgentId != null;
    const name = session.lastHandledByAgentName || `Staff #${session.lastHandledByAgentId}`;
    return (
        <Stack
            direction="row"
            spacing={0.5}
            alignItems="center"
            data-testid="handled-by"
            sx={{ minWidth: 0, color: handled ? PASTEL.primary : "text.secondary", ...sx }}
        >
            <SupportAgentOutlinedIcon sx={{ fontSize: 14, flexShrink: 0 }} />
            <Typography variant="caption" noWrap sx={{ fontWeight: handled ? 600 : 400, color: "inherit" }}>
                {handled ? `Ditangani oleh ${name}` : "Belum ditangani"}
            </Typography>
        </Stack>
    );
}
